export default __webpack_public_path__ + "static/media/BrandonGrotesque-Black.7cfc1a09.woff";